import Menu from './Compartido/Menu.jsx';
import DatosPeticion from './Peticion/DatosPeticion.jsx';
import Footer from './Compartido/Footer.jsx';

const Peticion = (props) => {
    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.websgrupo}
                ruta={props.ruta}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
            />

            <DatosPeticion
                propiedad={props.propiedad}
                llegada={props.llegada}
                salida={props.salida}
                difdias={props.difdias}
                adultos={props.adultos}
                ninos={props.ninos}
                bebes={props.bebes}
                ruta={props.ruta}
                numpropiedades={props.numpropiedades}
                websgrupo={props.websgrupo}
                precios={props.precios}
                moneda={props.moneda}
                lang={props.lang}
            />

            <Footer
                datos={props.websgrupo}
                lang={props.lang}
                ruta={props.ruta}
                logos_pie={props.logos_pie}
                websgrupo={props.websgrupo}
            />
        </main>
    );
}

export default Peticion;
